import { Component, Input } from '@angular/core';

@Component({
    selector: 'mt-wysiwyg-view',
    templateUrl: './wysiwyg-view.component.html',
})
export class WysiwygViewComponent {
    @Input() value: string = null;
}
